var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',[_c('h3',[_vm._v("403 Forbidden")])])
}]

export { render, staticRenderFns }